import React from 'react'
import PropTypes from 'prop-types'
import { HeroMain } from './index.style'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import { Heading1Serif } from '@components/TextStyles'
import AnimateSplitText from '@components/animation/AnimateSplitText'

const Hero = ({ title }) => {
  return (
    <HeroMain>
      <Container>
        <Spacer size={[160,280]} />

        <Heading1Serif as="h1">
          <AnimateSplitText>{title}</AnimateSplitText>
        </Heading1Serif>

        <Spacer size={[20, 30]} />
      </Container>
    </HeroMain>
  )
}

Hero.propTypes = {
  title: PropTypes.string,
}

export default Hero
